import React from "react";
import styled from "styled-components";
import { Swiper } from "swiper/react";
import "swiper/css";
import 'swiper/css/scrollbar';
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import {
  querySubscription,
  cancelSubShopifyScription,
  itemsSearch,
  filterDataSubTop,
} from "../../../services/app";
import { SwiperSlide } from "swiper/react";
import { useWindowSize } from "../../../hook/useWindowSize";
import FormButton from "../../../components/FormCustom2/Button";
import { TabSubscriptionByType } from "./TabSubscriptionByType";
import { CLAIM_DATA_KEY } from "../../../constants";
import TabsCustom from "../../../components/TabsCustom";
import { Tabs } from "antd";
import SortSub from "./SortSub";
import { useNavigate, useSearchParams } from "react-router-dom";
import ItemSubCard from "../../../components/ItemSubscription/ItemSubCard";
import {ModalConfirm} from "../../../components/ItemSubscription/ModalConfirm";
import {ModalUpdateCard} from "../../../components/ItemSubscription/ModalUpdateCard";
import * as Notification from "../../../Notification"
import { dateFormatNumber } from "../../../utils/helper";
import { FormSelect } from "../../../components/Form";
import { IconSelectClose } from "../../../components/Icons/IconSelectClose";

import {
  sortByField,
} from "../../../utils/helper";

import FilterDropdown from "./FilterDropdown";
import moment from "moment";
import SelectAvatar from "./SelectAvatar";
export const TabSubOption = {
  base: "suzu_base",
  plus: "suzu_plus",
  prime: "suzu_prime",
  ai: "cheercast",
};

export const SwiperWraper = styled(Swiper)`
  position: relative;
  .swiper-wrapper{
    padding-bottom: 30px;
  }
  &::after {
    content: "";
  }
`;
let timeout;
let currentValue;

export const TabSubscription = (props) => {
  const size = useWindowSize();
  const [searchParams, setSearchParams] = useSearchParams();
  const typeSub = searchParams.get("typesub");
  const itemId = searchParams.get("item_id");
  const { T, setLoading, setClaimData, user } = useApp();
  const [dataTab, setDataTab] = useState([]);
  const [bonusSub, setBonusSub] = useState([]);
  const [primeSub, setPrimeSub] = useState([]);
  const [aiSub, setAiSub] = useState([]);
  const [subCards, setSubCards] = useState([]);
  const [subSelected, setSubSelected] = useState({});
  const [filterEarnerSelected, setFilterEarnerSelected] = useState({});
  const navigate = useNavigate();
  const [tabClaimData, setTabClaimData] = useState([]);
  const [filterData, setFilterData] = useState({
    sort: 'priceDesc',
    page: 1,
    statuss: [],
    options: []
  });
  const [tabSub, setTabSub] = useState(typeSub || TabSubOption.base);
  const [swiper, setSwiper] = React.useState(null);
  const [isOpenModalCancel, setIsOpenModalCancel] = useState(false);
  const [isOpenModalUpdateCard, setIsOpenModalUpdateCard] = useState(false);
  const [nftOptions, setNFTOptions] = useState([]);

  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    if(itemId) {
      itemsSearch({keyword: itemId, page: 0, size: 20, itemTypes: [9]}).then((res) => {
        const options = res?.data?.data?.items?.rows || []
        if (options.length > 0) {
          setFilterEarnerSelected({
            value: options[0].id,
            img: options[0].img,
            label: options[0].name,
          })
          setFilterData({ ...filterData, id: options[0].id, page: 1 });
        }
      })

    }
    
  }, [itemId]);

  const getSlidePreview = () => {
    let preview = 0.8;
    if (size.width >= 1280) {
      preview = 4.2;
    } else if (size.width >= 1024) {
      preview = 3.4;
    } else if (size.width >= 890) {
      preview = 3;
    } else if (size.width >= 576) {
      preview = 2.3;
    } else if (size.width >= 400) {
      preview = 1.36;
    } else if (size.width >= 340) {
      preview = 1.16;
    } else if (size.width >= 320) {
      preview = 1.06;
    }
    return preview;
  };
  const loadData = async () => {
    setLoading(true);
    const result = await querySubscription();
    const resSubscriptions = result?.data?.data || {};
    let dataSubscriptions = [];
    if (Array.isArray(resSubscriptions.market)) {
      for (let item of resSubscriptions.market) {
        dataSubscriptions.push({...item, inMarket: true})
      }
    }
    if (Array.isArray(resSubscriptions.shopify)) {
      for (let item of resSubscriptions.shopify) {
        dataSubscriptions.push({ ...item, inMarket: false });
      }
    }
    const bonusSubData = resSubscriptions.bonusSubs || [];
    const primeSubData = resSubscriptions.primeSubs || [];
    const dataClaim = {
      giftIdsClaimed: resSubscriptions.giftIdsClaimed,
      giftClaimedNumber: resSubscriptions.giftClaimedNumber,
      hasPremium: resSubscriptions.hasPremium,
      hasUnlimit: resSubscriptions.hasUnlimit,
      maxAvatar: resSubscriptions.maxAvatar,
    };
    
    setSubCards(filterDataSubTop(dataSubscriptions, bonusSubData, null, primeSubData))
    setTabClaimData(dataClaim);
    setBonusSub(bonusSubData);
    setPrimeSub(primeSubData);
    setAiSub(resSubscriptions.aiSubs || []);
    setDataTab(dataSubscriptions || []);
    setLoading(false);
  };

  const handleCancelSubscription = () => {
    const subId = subSelected?.id || subSelected?.sub?.id ;
    cancelSubShopifyScription(subId)
      .then((res) => {
        if (res.data?.data) {
          setIsOpenModalCancel(false);
          loadData();
          Notification.success(
            T("Success! Your subscription has been canceled!")
          );
        } else {
          Notification.error(T("Failed to cancel subscription"));
        }
      })
      .catch((err) => {
        Notification.error(T("Failed to cancel subscription"));
      });
  };

  const onChangeTab = (tab) => {
    setTabSub(tab);
  };
  const handleSort = (val) => {
    setFilterData({
      ...filterData,
      sort: val.sort,
    });
  };
  const handleFilterData = (val) => {
    if (val?.page) {
      setFilterData({ ...filterData, ...val });
    }else{
      setFilterData({ ...filterData, ...val, page: 1 });
    }
  };
  const openModalCancelSubscription = (data) => {
    setIsOpenModalCancel(true);
    console.log(data)
    setSubSelected(data)
  };
  useEffect(() => {
    setFilterData({
      sort: "priceDesc",
      page: 1,
      options: [],
    });
  }, [tabSub])

  const handleSelectEaner = async (item) => {
    setFilterEarnerSelected(item)
    setFilterData({ ...filterData, id: item.value, page: 1 });
  };

  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] mt-[10px]">
      <div className="flex justify-between items-start gap-[40px]">
        <div className="asset-block w-full">
          <div className="flex flex-col mt-5 lg:mt-0 mb-10">
            <div className="text-[22px] lg:text-[30px] font-[600]">
              {T("Upcomming payments")}
            </div>
            <div className="mt-[20px] gap-[16px] showOver">
              <SwiperWraper
                slidesPerView={getSlidePreview()}
                spaceBetween={16}
                grabCursor={true}
                pagination={false}
                scrollbar={{ draggable: true }}
                watchOverflow={true}
                onSwiper={(s) => {
                  setSwiper(s);
                }}
              >
                {subCards?.map((report, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <ItemSubCard
                        itemData={report}
                        onCancleSub={openModalCancelSubscription}
                      />
                    </SwiperSlide>
                  );
                })}
              </SwiperWraper>
            </div>
          </div>
          <div className="flex justify-between items-center flex-wrap lg:flex-nowrap">
            <div className="text-[22px] lg:text-[30px] font-[600]">
              {T("Active Subscription")}
            </div>
            <div className={`flex justify-start mt-[12px] lg:mt-0 lg:justify-end items-center space-x-[15px] ${tabSub === TabSubOption.plus ? 'w-full lg:w-auto': ''}`}>
              {tabSub === TabSubOption.plus && <div className="w-full">
                <SelectAvatar handleChangeVal={(val) => handleSelectEaner(val)} selectedItem={filterEarnerSelected}/>
              </div>}
              <div className="flex-1 flex justify-end items-center gap-3">
                <FilterDropdown
                  filterData={filterData}
                  setFilterData={(val) => handleFilterData(val)}
                  tabType={tabSub}
                />
                <SortSub
                  filterData={filterData}
                  setFilterData={(val) => handleSort(val)}
                />
              </div>
            </div>
          </div>

          <TabsCustom
            spaceItem={size.width > 1024 ? 32 : 30}
            className="v2 mt-[18px] lg:mt-[34px] min-h-[calc(100vh-600px)]"
            activeKey={tabSub}
            onChange={(e) => onChangeTab(e)}
            destroyInactiveTabPane={true}
          >
            <Tabs.TabPane tab={T("Art Basic")} key={TabSubOption.base}>
              <TabSubscriptionByType
                dataTab={dataTab}
                loadData={loadData}
                filterData={filterData}
                handleFilterData={handleFilterData}
                subType={1}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={T("ART PLUS")} key={TabSubOption.plus}>
              <TabSubscriptionByType
                dataTab={bonusSub}
                loadData={loadData}
                filterData={filterData}
                handleFilterData={handleFilterData}
                subType={2}
              />
            </Tabs.TabPane>            
            <Tabs.TabPane tab={T("ART PRIME")} key={TabSubOption.prime}>
              <TabSubscriptionByType
                dataTab={primeSub}
                loadData={loadData}
                filterData={filterData}
                handleFilterData={handleFilterData}
                subType={4}
              />
            </Tabs.TabPane>
            {/* <Tabs.TabPane tab={T("Avatar")} key={TabSubOption.ai}>
              <TabSubscriptionByType
                dataTab={aiSub}
                loadData={loadData}
                filterData={filterData}
                handleFilterData={handleFilterData}
                subType={3}
              />
            </Tabs.TabPane> */}
          </TabsCustom>
        </div>
      </div>
      {isOpenModalCancel && (
        <ModalConfirm
          title={T("Cancel Subscription")}
          des={T(
            "Are you sure you want to cancel this subscription? After confirm, the subscription charge will be canceled on {date} and you will not be able to resubscribe to that subscription."
          ).replace(
            "{date}",
            dateFormatNumber(subSelected?.end_date, "YYYY/MM/DD")
          )}
          onClose={() => setIsOpenModalCancel(false)}
          onSubmit={() => handleCancelSubscription()}
        />
      )}
      {/* {isOpenModalUpdateCard && (
        <ModalUpdateCard
          title={T("Update card information")}
          onClose={() => setIsOpenModalUpdateCard(false)}
        />
      )} */}
    </div>
  );
};
